import { useEffect, useState } from "react";
import axios from "axios";
import { RiArrowDownSLine } from "react-icons/ri";
import searchIcon from "../../assets/admin/search.svg";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AiOutlineLike } from "react-icons/ai";
import PaginationComponent from "../../utils/PaginationComponent";
import TableLoader from "../../utils/TableLoader";
import { FaMagic } from "react-icons/fa";
import { IoMdArrowRoundForward } from "react-icons/io";
import { TbEdit } from "react-icons/tb";
import { BiSolidTrashAlt } from "react-icons/bi";

const WineFood = () => {
  const { rest_slug2 } = useParams();
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const RestId = localStorage.getItem("currentRestId");
  const [searchWineQuery, setSearchWineQuery] = useState("");
  const [searchDishQuery, setSearchDishQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState({ main: false, edit: false, save: false });
  const [showOption, setShowOption] = useState({ wine: false, dish: false, option: false });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [foodList, setFoodList] = useState([]);
  const [showFilterForMobile, setShowFilterForMobile] = useState(false);
  const [selectedWineId, setSelectedWineId] = useState(null);
  const [selectedDishId, setSelectedDishId] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [filteredWineArray, setFilteredWineArray] = useState([]);
  const [filteredDishArray, setFilteredDishArray] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [selectedPairId, setSelectedPairId] = useState(null);

  const [filteredOptionArray, setFilteredOptionArray] = useState(
    [
      { label: "Abbinamento Perfetto", value: "Abbinamento Perfetto", icon: <><AiOutlineLike fontSize={23} color="black" gap={0} /><AiOutlineLike fontSize={23} color="black" /><AiOutlineLike fontSize={23} color="black" /></> },
      { label: "Buon Abbinamento", value: "Buon Abbinamento", icon: <AiOutlineLike fontSize={20} color="black" /> },
      { label: "Abbinamento Creativo", value: "Abbinamento Creativo", icon: <FaMagic fontSize={20} color="black" /> },
    ]
  );

  const filteredOptionList = filteredOptionArray.filter((option) =>
    option?.value?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleDropdown = (key) => {
    setShowOption((prev) => ({
      wine: false,
      dish: false,
      option: false,
      [key]: !prev[key],
    }));
  };

  const handleWineSelection = (wineId) => {
    setSelectedWineId((prevWineId) => (prevWineId === wineId ? null : wineId));
  };
  const handleDishSelection = (dishId) => {
    setSelectedDishId((prevWineId) => (prevWineId === dishId ? null : dishId));
  };
  const handleOptionSelection = (option) => {
    setSelectedOption((prevWineId) => (prevWineId === option ? null : option))
  };

  const handleEditClick = (item) => {
    setSelectedWineId(item?.wine_stock_id);
    setSelectedDishId(item?.dish_id);
    setSelectedOption(item?.pairing_level);
  };

  const getPairOptionData = async () => {
    try {
      const wineParams = searchWineQuery ? { search: searchWineQuery } : {};
      const dishParams = searchDishQuery ? { search: searchDishQuery } : {};

      const [wineResponse, dishResponse] = await Promise.all([
        axios.get(`${apiUrl}/api/v1/fetch-wine-stock/${rest_slug2}`, {
          params: wineParams,
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${apiUrl}/api/v1/restaurants/${rest_slug2}/fetch-dishes`, {
          params: dishParams,
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setFilteredWineArray(wineResponse?.data || []);
      setFilteredDishArray(dishResponse?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getWinePairData = async () => {
    setIsLoading(true);
    try {
      let params;
      // if (searchText) {
      //     params = {
      //         pageNumber: page,
      //         size: rowsPerPage,
      //         search: searchText,
      //     };
      // } else {
      //     params = {
      //         pageNumber: page,
      //         size: rowsPerPage,
      //     };
      // }
      params = {
        pageNumber: page,
        size: rowsPerPage,
      };
      const response = await axios.get(`${apiUrl}/api/v1/restaurants/${RestId}/wine-dish-pairing`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        params,
      });

      const data = response?.data;
      setFoodList(data?.data);
      setTotalPages(data?.total);
    } catch (error) {
      console.error('Error fetching order data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsLoading({ ...isLoading, save: true });
    try {
      const payload = {
        wine_stock_id: selectedWineId,
        dish_id: selectedDishId,
        pairing_level: selectedOption,
      };
      const response = await axios.post(
        `${apiUrl}/api/v1/restaurants/${rest_slug2}/wine-dish-pairing`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      getWinePairData();
      toast.success(response?.data?.message, {
        theme: 'colored',
        autoClose: 1000,
      });
      setSelectedWineId([])
      setSelectedDishId([])
      setSelectedOption("")
    } catch (error) {
      console.error('Error adding dish:', error?.response?.data?.errors);
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: 'colored',
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error(error?.response?.data?.message, {
          theme: 'colored',
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading({ ...isLoading, save: false });
    }
  };

  const handleDelete = async (Id) => {
    if (!Id) {
      console.error('Error: ID is required to delete a menu.');
      return;
    }
    setIsLoading({ ...isLoading, main: true });
    try {
      const response = await axios.delete(`${apiUrl}/api/v1/wine-dish-pairing/${Id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      getWinePairData();
      toast.success(response?.data?.message, { theme: "colored", autoClose: 1000 })
    } catch (error) {
      console.error('Error deleting dish:', error?.response?.data?.message || error.message);
      toast.error(error?.response?.data?.message || error.message, { theme: 'colored', autoClose: 3000 });
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShowFilterForMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOption({
          wine: false,
          dish: false,
          option: false
        });
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    getPairOptionData();
    getWinePairData();
  }, [searchWineQuery, searchDishQuery, page, rowsPerPage])

  useEffect(() => {
    setSearchWineQuery("");
    setSearchDishQuery("");
    setSearchQuery("");
  }, [showOption])

  return (
    <>
      <section className="relative">
        <h3 className="text-2xl text-left font-bold mb-2 poppins-medium">Abbinamento Vino-Piatti</h3>
        <div className="w-full flex items-center mb-5 sm:mt-5 mt-0  justify-center flex-wrap">
          <div className="w-full flex md:grid-cols-2 gap-4">
            <div className={`${showFilterForMobile ? "hidden transition-all duration-500 ease-in-out" : ""}w-full flex flex-col lg:flex-row gap-2 mt-5`}>
              {/* wine */}
              <div className="w-full flex flex-col lg:flex-row gap-2 mt-5 dropdown-container">
                <div className="relative group w-full">
                  <button
                    className={`${showOption.wine ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border bg-[#fff] border-[#F2C3CA] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#8B2433] font-medium shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("wine")}
                  >
                    <span className="mr-2 flex items-center gap-3">
                      {selectedWineId
                        ? (filteredWineArray.find((wine) => wine.id === selectedWineId)?.wine?.name?.length > 25
                          ? filteredWineArray.find((wine) => wine.id === selectedWineId)?.wine?.name.slice(0, 25) + "..."
                          : filteredWineArray.find((wine) => wine.id === selectedWineId)?.wine?.name) || "Scegli Vino"
                        : "Scegli Vino"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${showOption.wine ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${showOption.wine ? "opacity-100 z-50 relative visible" : "opacity-0 z-20 overflow-hidden invisible"
                      } bg-[#fff] h-[200px] border-[#F2C3CA] overflow-y-scroll absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none cursor-pointer w-full placeholder:text-sm" placeholder="scegi vino"
                        value={searchWineQuery}
                        onChange={(e) => setSearchWineQuery(e.target.value)}
                      />
                    </div>
                    {filteredWineArray.map((wine) => (
                      <label
                        htmlFor=""
                        key={wine?.id}
                        className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          name="wineSelection"
                          className="outline-none cursor-pointer"
                          checked={selectedWineId === wine?.id}
                          onChange={() => handleWineSelection(wine?.id)}
                        />
                        <span className="text-[#303030] rounded-md flex items-center gap-3 poppins-regular text-xs">
                          {wine?.wine?.name}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
              {/* dish */}
              <div className="w-full flex flex-col lg:flex-row gap-2 mt-5 dropdown-container">
                <div className="relative group w-full">
                  <button
                    className={`${showOption.dish ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border bg-[#fff] border-[#F2C3CA] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#8B2433] font-medium   shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("dish")}
                  >
                    <span className="mr-2 flex items-center gap-3">
                      {selectedDishId
                        ? (filteredDishArray.find((dish) => dish?.id === selectedDishId)?.name?.length > 25
                          ? filteredDishArray.find((dish) => dish?.id === selectedDishId)?.name.slice(0, 25) + "..."
                          : filteredDishArray.find((dish) => dish?.id === selectedDishId)?.name) || "Scegli Piatto"
                        : "Scegli Piatto"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${showOption.dish ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${showOption.dish ? "opacity-100 z-50 relative visible" : "opacity-0 z-20 overflow-hidden invisible"
                      } bg-[#fff] h-[200px] border-[#F2C3CA] overflow-y-scroll absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none cursor-pointer w-full placeholder:text-sm" placeholder="scegi piatto"
                        value={searchDishQuery}
                        onChange={(e) => setSearchDishQuery(e.target.value)}
                      />
                    </div>
                    {filteredDishArray?.map((dish) => (
                      <label
                        htmlFor=""
                        key={dish?.id}
                        className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          name="dishSelection"
                          className="outline-none cursor-pointer"
                          checked={selectedDishId === dish?.id}
                          onChange={() => handleDishSelection(dish?.id)}
                        />
                        <span className="text-[#303030] rounded-md flex items-center gap-3 poppins-regular text-xs">
                          {dish?.name}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
              {/* option */}
              <div className="w-full flex flex-col lg:flex-row gap-2 mt-5 dropdown-container">
                <div className="relative group w-full">
                  <button
                    className={`${showOption.option ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border bg-[#fff] font-medium border-[#F2C3CA] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#8B2433] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("option")}
                  >
                    <span className="mr-2 flex items-center gap-3">
                      {selectedOption
                        ? filteredOptionArray.find((wine) => wine.value === selectedOption)?.label || "Abbinamento"
                        : "Abbinamento"}
                    </span>

                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${showOption.option ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${showOption.option ? "opacity-100 z-50 visible relative" : "opacity-0 z-20 overflow-hidden invisible"
                      } bg-[#fff] h-[200px] border-[#F2C3CA] overflow-y-scroll absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none cursor-pointer w-full placeholder:text-sm" placeholder="Abbinamento"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    <div className="border-b border-[#8b24331f] pt-1"></div>
                    {filteredOptionList?.map((option, index) => (
                      <div
                        className="flex items-center border-b border-[#8b24331f]"
                        key={index}
                      >
                        {option.icon}
                        <label
                          htmlFor=""
                          className="px-0 py-2 flex ml-2 align-center justify-between flex-row-reverse gap-[15px] filter_list_btn w-full"
                        >
                          <input
                            type="checkbox"
                            className="outline-none cursor-pointer"
                            checked={selectedOption === option.value}
                            onChange={() => handleOptionSelection(option.value)}
                          />
                          <span className="text-[#303030] rounded-md flex items-center gap-3 poppins-regular text-xs">{option?.label}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {isLoading?.save ? (
                <button disabled type="button"
                  className="btn-invia flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group">
                  <svg
                    aria-hidden="true"
                    className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <button className="btn-invia flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                  onClick={handleSave}
                >
                  <span className="poppins-regular mr-2">Invia</span>
                  <IoMdArrowRoundForward size={"20px"} />
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3 className="text-xl text-left font-bold mb-2 poppins-medium">Abbinamento Vino-Piatto</h3>
        <div className="wine-main-stock w-auto h-auto bg-[#F8F8F8] border-[1.5px] border-[#8B24332B]
         text-[#303030] pt-3 pb-0 px-6 rounded-xl shadow">
          <table className="w-full text-left ristoranti_table">
            <thead>
              <tr className="border-b ">
                <th className="pb-3 pr-2 text-left poppins-medium">Sr.No</th>
                <th className="pb-3 pr-2 text-left poppins-medium">Vino</th>
                <th className="pb-3 px-2 text-left poppins-medium">Piatto</th>
                <th className="pb-3 px-2 text-left poppins-medium">Livello</th>
                <th className="pb-3 px-2 text-left poppins-medium">Azione</th>
              </tr>
            </thead>
            {isLoading?.main ? (
              <TableLoader />
            ) : (
              <tbody>
                {foodList && foodList?.length > 0 ? (
                  foodList?.map((item, index) => (
                    <tr key={index} className="border-b sm:text-sm text-xs">
                      <td className="py-4 text-left poppins-regular">
                        <span className="inline-flex items-center justify-center">
                          {index + 1}
                        </span>
                      </td>
                      <td className="py-4 px-2 text-left poppins-regular">{item?.wine_stock?.wine?.name || "-"}</td>
                      <td className="py-4 px-2 text-left poppins-regular">
                        <span className="table-h inline-flex items-center justify-center lg:w-auto w-[250px]  lg:h-auto h-[100px] overflow-auto ">
                          {item?.dish?.name || "-"}
                        </span>
                      </td>
                      <td className="py-4 px-2 text-left poppins-regular">
                        {item?.pairing_level || "-"}
                      </td>
                      <td className="py-4 px-2 text-left poppins-regular">
                        <button
                          className="text-red-700 mx-2"
                          onClick={() => handleEditClick(item)}
                        >
                          {/* <img
                            src={edit}
                            alt="Edit"
                            height={15}
                            width={15}
                          /> */}
                          <TbEdit size={"20px"} />
                        </button>
                        <button className="text-red-700"
                          onClick={() => { setDialog(true); setSelectedPairId(item?.id) }}>
                          {/* <img
                            src={deletee}
                            alt="Delete"
                            height={13}
                            width={13}
                          /> */}
                          <BiSolidTrashAlt size={"18px"} />
                        </button>
                        {dialog && (
                          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                              <div className="px-6 py-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                  Are you sure you want to delete the Paring?
                                </h3>
                              </div>
                              <div className="px-6 py-4 flex justify-end space-x-4">
                                <button
                                  onClick={() => { handleDelete(selectedPairId); setDialog(false); }}
                                  className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                                >
                                  Yes
                                </button>
                                <button
                                  onClick={() => setDialog(false)}
                                  className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="py-4 text-center">
                      No Pairing found.
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>

        {foodList && foodList?.length > 0 && (
          <PaginationComponent
            page={page}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
          />
        )}
      </section>
    </>
  );
};

export default WineFood;